export enum CallType {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
    WEBRTCINBOUND = 'WEBRTCINBOUND',
    FORWARD = 'FORWARD',
    SIPFORWARD_USER = 'SIPFORWARD_USER',
    SIPFORWARD_PRFL = 'SIPFORWARD_PRFL',
    FAXOUT = 'FAXOUT',
}
